
import { createColumn, formatAsDate, formatAsCurrency } from '@/util/table';
import PaginationMixin from '@/mixins/PaginationMixin';
import { OrderStatus } from '@/repositories/OrderRepository';
import RequestOrder from '@/models/RequestOrder';
import { handleErrorUI } from '@/util/error';
import CommonMixin from '@/mixins/CommonMixin';

export default {
  mixins: [CommonMixin, PaginationMixin],
  data() {
    return {
      data: [],
      loading: true,
      appends: [
        createColumn('reviewDate', 'Reviewed Date', formatAsDate),
        createColumn('finalizedDate', 'Finalized Date', formatAsDate),
        createColumn(
          'grandTotal',
          'Request Grand Total',
          formatAsCurrency(row => row.currency.code)
        ),
        createColumn('paymentMethod', 'Payment Method'),
        createColumn('installationDate', 'Date', formatAsDate),
        createColumn('installationTime', 'Time')
      ],
      selectedOrder: new RequestOrder(),
      detailDialogShown: false
    };
  },
  async created() {
    await this.fetchOrders();
  },
  methods: {
    async fetchOrders() {
      this.loading = true;
      try {
        const { tenant } = await this.$repo.session.fetch();
        const { data, pagination } = await this.$repo.order.getOrderWithStatus(
          tenant,
          OrderStatus.FINISHED,
          this.pagination
        );
        this.data = data;
        this.updatePagination(pagination);
      } catch (err) {
        handleErrorUI(err);
      } finally {
        this.loading = false;
      }
    },
    async paginationChangeHandler() {
      await this.fetchOrders();
    },
    showDetailDialog(order: RequestOrder) {
      this.selectedOrder = order;
      this.detailDialogShown = true;
    }
  }
};
